import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const ValidatedIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 7H17V9H15V11H13V13H11V15H9V13H7V11H5V13H7V15H9V17H11V15H13V13H15V11H17V9H19V7Z"
        fill={fillColor || '#111112'}
      />
    </svg>
  );
};

export { ValidatedIcon };
